import React from 'react';

const Blog = () => {
    return (
        <div className="my-5 text-center text-warning text-uppercase">
            <h1>Blogs are coming soon.....!</h1>
        </div>
    );
};

export default Blog;